<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: [],
      timeout: null,
      requestSeq: 0,
      destroyed: false
    };
  },

  created() {
    GeocoderFactory().then(geocoder => {
      if (this.destroyed) {
        return;
      }

      this.geocoder = geocoder;

      if (this.value.value) {
        this.items.push(this.value);
        this.select = this.value;
      }
    });
  },

  watch: {
    search(val) {
      if (!val) {
        this.resetPending();
        this.resetItems();
        return;
      }

      if (val !== this.selectText()) {
        this.querySelections(val);
      }
    }
  },

  beforeDestroy() {
    this.destroyed = true;
    this.resetPending();
  },

  methods: {
    selectText() {
      if (typeof this.select === "string") {
        return this.select;
      }

      return this.select && this.select.text ? this.select.text : null;
    },

    resetPending() {
      this.requestSeq++;

      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    resetItems() {
      this.items = this.select && typeof this.select === "object" ? [this.select] : [];
    },

    querySelections(value) {
      this.resetPending();

      if (!this.geocoder || this.destroyed) {
        return;
      }

      const seq = this.requestSeq;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoder.autocomplete(value).then(items => {
          if (seq !== this.requestSeq) {
            return;
          }

          this.items = items.slice();
        }).catch(error => {
          if (seq !== this.requestSeq || this.geocoder.isCancel(error)) {
            return;
          }

          this.items = [];
        }).finally(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.resetPending();
      this.items = o && typeof o === "object" ? [o] : [];
      this.$emit("change", o);
    }
  }
};
</script>
